export default "__VITE_ASSET__BpPXoLRj__"